/* cdds/count_types */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    caats_isLoading: false,
    caats_datasets: {},
    params: {},
    caats_traffic_type: [],
    caats_origin_region_cat_1: [],
    caats_origin_country: [],
    caats_origin_city: [],
    caats_origin_airport: [],
    caats_destination_country: [],
    caats_destination_city: [],
    caats_destination_airport: [],
    caats_airline_nat: [],
    caats_airline_name: [],

}

// getters
const getters = {
    caats_isLoading: state => {
        return state.caats_isLoading;
    },
    caats_filters: state => {
        return state.caats_filters;
    },
    caats_datasets: state => {
        return state.caats_datasets;
    },
    caats_params: state => {
        return state.params;
    },
    caats_traffic_type: state => {
        return state.caats_traffic_type;
    },
    caats_origin_region_cat_1: state => {
        return state.caats_origin_region_cat_1;
    },
    caats_origin_country: state => {
        return state.caats_origin_country;
    },
    caats_origin_city: state => {
        return state.caats_origin_city;
    },
    caats_origin_airport: state => {
        return state.caats_origin_airport;
    },
    caats_destination_country: state => {
        return state.caats_destination_country;
    },
    caats_destination_city: state => {
        return state.caats_destination_city;
    },
    caats_destination_airport: state => {
        return state.caats_destination_airport;
    },
    caats_airline_nat: state => {
        return state.caats_airline_nat;
    },
    caats_airline_name: state => {
        return state.caats_airline_name;
    },
}

// actions
const actions = {
    getCaatsTrafficType(context, payload) {
        //state.caats_isLoading = true;
        var _params = {};
        var main_filters = payload.main_filters;
        if (main_filters.routes !== null) {
            _params.routes = main_filters.routes;
        }
        if (main_filters.flight_type !== null) {
            if (main_filters.flight_type != "") {
                _params.flight_type = main_filters.flight_type;
            }
        }
        const request = {
            params: qs.parse(_params)
        };

        // query data
        instance.get('caats_traffic_types', request)
            .then(response => {
                payload.stateFilters.forEach(function(stateName) {
                    if (stateName == "caats_traffic_types") {
                        state.caats_traffic_type = response.data.traffic_type;
                    }
                })
                state.caats_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/caats_traffic_types] syntax errors under instant.get");
            })
    },

    getCaatsOptions(context, payload) {
        //state.caats_isLoading = true;
        var _params = {};
        var main_filters = payload.main_filters;

        if (main_filters.routes.selected.value !== "") {
            _params.routes = main_filters.routes.selected.value;
        }
        if (main_filters.destination_country.selected.value !== "") {
            _params.destination_country = main_filters.destination_country.selected.value;
        }
        if (main_filters.origin_region_cat_1.selected.value !== "") {
            _params.origin_region_cat_1 = main_filters.origin_region_cat_1.selected.value;
        }
        if (main_filters.origin_country.selected.value !== "") {
            _params.origin_country = main_filters.origin_country.selected.value;
        }
        if (main_filters.origin_city.selected.value !== "") {
            _params.origin_city = main_filters.origin_city.selected.value;
        }
        if (main_filters.origin_airport.selected.value !== "") {
            _params.origin_airport = main_filters.origin_airport.selected.value;
        }
        if (main_filters.destination_city.selected.value !== "") {
            _params.destination_city = main_filters.destination_city.selected.value;
        }
        if (main_filters.destination_airport.selected.value !== "") {
            _params.destination_airport = main_filters.destination_airport.selected.value;
        }
        if (main_filters.airline_nat.selected.value !== "") {
            _params.airline_nat = main_filters.airline_nat.selected.value;
        }
        // if (main_filters.start !== null && main_filters.end !== null) {
        //     _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
        //     _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
        // }

        const request = {
            params: qs.parse(_params)
        };

        // query data
        instance.get('caats_options', request)
            .then(response => {
                payload.stateFilters.forEach(function(stateName) {
                    if (stateName == "caats_options") {
                        if (response.data.origin_region_cat_1 !== undefined) {
                            state.caats_origin_region_cat_1 = response.data.origin_region_cat_1
                            state.caats_origin_country = [];
                            state.caats_origin_city = [];
                            state.caats_origin_airport = [];
                            state.caats_airline_name = [];
                        }
                        if (response.data.origin_country !== undefined) {
                            state.caats_origin_country = response.data.origin_country;
                            state.caats_origin_city = [];
                            state.caats_destination_city = [];
                            state.caats_origin_airport = [];
                            state.caats_destination_airport = [];
                            state.caats_airline_nat = [];
                        }
                        if (response.data.origin_city !== undefined) {
                            state.caats_origin_city = response.data.origin_city;
                        }
                        if (response.data.origin_airport !== undefined) {
                            state.caats_origin_airport = response.data.origin_airport;
                        }
                        if (response.data.destination_city !== undefined) {
                            state.caats_destination_city = response.data.destination_city;
                        }
                        if (response.data.destination_airport !== undefined) {
                            state.caats_destination_airport = response.data.destination_airport;
                        }
                        if (response.data.airline_nat !== undefined) {
                            state.caats_airline_nat = response.data.airline_nat;
                        }
                        if (response.data.airline_name !== undefined) {
                            state.caats_airline_name = response.data.airline_name;
                        }
                    }
                })
                state.caats_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/caats_options] syntax errors under instant.get");
            })
    },


    getCaatsDataSets(context, payload) {
        state.caats_isLoading = true;
        var _params = {};
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            state.params = {
                start: main_filters.start,
                end: main_filters.end,
                origin_region_cat_1: 'All',
                origin_country: 'All',
                origin_city: 'All',
                origin_airport: 'All',
                desitnation_country: 'All',
                destination_city: 'All',
                destination_airport: 'All',
            }
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = main_filters.start;
                _params.end = main_filters.end;
            }
            if (main_filters.routes.selected.value !== "") {
                _params.routes = main_filters.routes.selected.value;
            }
            if (main_filters.flight_type.selected.value !== "") {
                _params.flight_type = main_filters.flight_type.selected.value;
            }
            if (main_filters.stop_type.selected.value !== "") {
                _params.stop_type = main_filters.stop_type.selected.value;
            }
            if (main_filters.traffic_type_selected !== "") {
                _params.traffic_type = main_filters.traffic_type_selected;
            }
            if (main_filters.destination_country.selected.value !== "") {
                _params.destination_country = main_filters.destination_country.selected.value;
            }
            if (main_filters.origin_region_cat_1.selected.value !== "") {
                _params.origin_region_cat_1 = main_filters.origin_region_cat_1.selected.value;
                state.params.origin_region_cat_1 = main_filters.origin_region_cat_1.selected.value;
            }
            if (main_filters.origin_country.selected.value !== "") {
                _params.origin_country = main_filters.origin_country.selected.value;
                state.params.origin_country = main_filters.origin_country.selected.value;
            }
            if (main_filters.origin_city.selected.value !== "") {
                _params.origin_city = main_filters.origin_city.selected.value;
                state.params.origin_city = main_filters.origin_city.selected.value;
            }
            if (main_filters.origin_airport.selected.value !== "") {
                _params.origin_airport = main_filters.origin_airport.selected.value;
                state.params.origin_airport = main_filters.origin_airport.selected.value;
            }
            if (main_filters.destination_city.selected.value !== "") {
                _params.destination_city = main_filters.destination_city.selected.value;
                state.params.destination_city = main_filters.destination_city.selected.value;
            }
            if (main_filters.destination_airport.selected.value !== "") {
                _params.destination_airport = main_filters.destination_airport.selected.value;
                state.params.destination_airport = main_filters.destination_airport.selected.value
            }
            if (main_filters.airline_nat.selected.value !== "") {
                _params.airline_nat = main_filters.airline_nat.selected.value;
            }
            if (main_filters.airline_name.selected.value !== "") {
                _params.airline_name = main_filters.airline_name.selected.value;
            }
        }

        const request = {
            params: qs.parse(_params)
        };
        state.caats_datasets = {};
        // query data
        instance.get('caats/data', request)
            .then(response => {
                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "caats_data") {
                        if (response.data.total !== undefined && response.data.rows !== undefined) {
                            state.caats_datasets = response.data;
                        }
                    }

                })
                state.caats_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/caats/data] syntax errors under instant.get");
            })
    }

}

// mutations
const mutations = {
    SomeFunction(state, payload) {}
}

export default {
    state,
    getters,
    actions,
    mutations
}